import { Link } from '@tanstack/react-router'
import { Button } from '@volee/ui'

import { useSignOut } from '../data/use-sign-out.ts'
import { messages } from '../messages/index.ts'

/** The way out. Rendered by the shell's header and by `/forbidden`; the user menu has its own. */
export function SignOutButton({ size }: { size?: 'sm' }) {
  const signOut = useSignOut()
  return (
    <Button variant="outline" size={size} onClick={() => void signOut()}>
      {messages.navigation.signOut}
    </Button>
  )
}

/** The way in, for a surface that has to offer it: the header, and `/forbidden`. */
export function SignInButton({ returnTo, size }: { returnTo: string; size?: 'sm' }) {
  return (
    <Button asChild variant={size === undefined ? 'default' : 'outline'} size={size}>
      <Link to="/sign-in" search={{ returnTo }}>
        {messages.navigation.signIn}
      </Link>
    </Button>
  )
}
